__turbopack_context__.v({
  "error": "styles-module__UeKf5q__error",
  "productList": "styles-module__UeKf5q__productList",
});
